export const predicateAppState = (key: string | string[], value?: any) => (action: any) => {
  const { payload = {} } = action;
  if (typeof payload !== 'object') return false;
  const isKeyOk = Array.isArray(key) ? key.find((k) => k in payload) : key in payload;
  const isValueOk = typeof value === 'undefined' || (payload as any)[key] === value;
  return action.type === 'PATCH_APPSTATE' && isKeyOk && isValueOk;
};
